import axios from 'axios';

const getUsers = () => axios.get('userProfile/users');
const getProfile = () => axios.get('userProfile/me');
const switchUser = ({ authProviderId }) => axios.post('login/switchUser', { authProviderId });
const loginWithToken = ({ token }) => axios.get(`login/public?jwt=${token}`);
const viewLoadWithNonce = ({ ln }) => axios.get(`login/load?ln=${ln}`);
const getUserProfile = ({ userId }) => axios.get(`userProfile/${userId}`);
const getMyLoads = () => axios.get('simpleDashboard');
const updateContactInfo = ({ user }) => axios.post('userProfile/contactInfo', user);
const updateCDLInfo = ({ userCDL }) => axios.post('userProfile/userDriverInfo', userCDL);
const getMyNotificationSettings = () => axios.get('userProfile/notificationSettings');
const updateMyNotificationSettings = ({ settings }) => axios.post('userProfile/notificationSettings', settings);
const updateUserNotificationSettings = ({ userAuthId, settings }) =>
  axios.post(`userProfile/${userAuthId}/notificationSettings`, settings);
const setRoles = ({ userAuthId, roles }) => axios.post('userProfile/userRoles', { userAuthId, roles });
const getUserNotificationSettings = ({ userAuthId }) => axios.get(`userProfile/${userAuthId}/notificationSettings`);
const updateUserBqaInfo = ({ bqaProfile }) => axios.post('userProfile/userBqaInfo', bqaProfile);
const verifyBqaProfile = userAuthId => axios.post(`userProfile/${userAuthId}/verifyBqaProfile`, {});

export default {
  getUsers,
  getProfile,
  getMyLoads,
  updateContactInfo,
  updateCDLInfo,
  getUserProfile,
  getMyNotificationSettings,
  updateMyNotificationSettings,
  setRoles,
  getUserNotificationSettings,
  updateUserNotificationSettings,
  switchUser,
  loginWithToken,
  viewLoadWithNonce,
  updateUserBqaInfo,
  verifyBqaProfile,
};



// WEBPACK FOOTER //
// ./src/api/user.js